import { Route, Routes } from 'hotel/navigation';

import HotelSearch from 'pages/HotelSearch';
import HotelDetail from 'pages/HotelSearch/HotelDetail';
import HotelSearchResultList from 'pages/HotelSearch/HotelSearchResultList';

const HotelSearchRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HotelSearch />}>
        <Route index element={<HotelSearchResultList />} />
        <Route path=":hotelId" element={<HotelDetail />} />
      </Route>
    </Routes>
  );
};

export default HotelSearchRoutes;
